import React, { useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";
import { Download, Search } from "lucide-react";

export default function Resources() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");

  useEffect(() => { api.get("/resources").then(({ data }) => setItems(data)); }, []);

  const cats = useMemo(() => ["All", ...Array.from(new Set(items.map((x) => x.category)))], [items]);

  const filtered = items.filter((x) =>
    (cat === "All" || x.category === cat) &&
    (!q || x.title.toLowerCase().includes(q.toLowerCase()))
  );

  return (
    <div data-testid="dashboard-resources-page">
      <div className="overline text-[var(--lh-mauve)] mb-3">Resource Library</div>
      <h1 className="font-serif-display text-5xl tracking-tighter leading-[0.95]">Your marketing <em>shortcut.</em></h1>

      <div className="mt-10 grid md:grid-cols-12 gap-5 items-end">
        <div className="md:col-span-7">
          <div className="overline text-[var(--lh-muted)] mb-2">Search</div>
          <div className="relative">
            <input value={q} onChange={(e) => setQ(e.target.value)} className="input-line pr-10" placeholder="e.g. content calendar, brand voice" data-testid="resources-search-input" />
            <Search size={16} className="absolute right-1 top-3.5 text-[var(--lh-muted)]" />
          </div>
        </div>
        <div className="md:col-span-5">
          <div className="overline text-[var(--lh-muted)] mb-2">Category</div>
          <select className="input-line" value={cat} onChange={(e) => setCat(e.target.value)} data-testid="resources-category-select">
            {cats.map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
      </div>

      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((r) => (
          <article key={r.resource_id} className="editorial-card p-7 flex flex-col" data-testid={`resource-card-${r.resource_id}`}>
            <div className="overline text-[var(--lh-mauve)] mb-3">{r.category}</div>
            <h3 className="font-serif-display text-2xl leading-tight">{r.title}</h3>
            <p className="text-sm font-light text-[var(--lh-text)] mt-3 flex-1">{r.description}</p>
            <a href={r.file_url || "#"} className="overline text-[var(--lh-black)] hover:text-[var(--lh-mauve)] mt-5 inline-flex items-center gap-2" data-testid={`resource-download-${r.resource_id}`}>
              <Download size={12} /> Download
            </a>
          </article>
        ))}
      </div>
    </div>
  );
}
